jQuery(function($) {
  var changed = 0;

  // Add sticky header to tables
  $('body').scroll(function() {
    if ($('.comparison-titles').length) {
      if ($(window).scrollTop() >= $('#top').offset().top) {
        $('.comparison-titles').addClass('comparison-titles-following');
      }
      else {
        $('.comparison-titles').removeClass('comparison-titles-following');
      }
    }
  });

  // Check all radio buttons for prior change
  $.each($('.persistent'), function() {
    if ($(this).is(':checkbox')) {
      let nb = localStorage[$(this).attr('id')];
      if (nb === '1') {
        $(this).prop('checked', true).trigger('change');
      }
      if (nb === '0') {
        $(this).removeAttr('checked');
      }
    }
    else {
      let nm = localStorage[$(this).attr('name')];
      if (nm) {
        if ($(this).is(':radio')) {
          if ($(this).val() === nm) {
            $(this).prop('checked', true);
          }
        }
        else {
          $(this).val(nm);
        }
        changed ++;
      }
    }
  });

  // If nothing has ever been changed, and the user is on mobile,
  // collapse all accordions but the first one.
  if (changed === 0 && $(window).width() < 768) {
    $('.program-section-filter .persistent:gt()').each(function() {
      localStorage[$(this).attr('name')] = $(this).val();
      $(this).click();
    });
  }

  // Save radio state to localstorage on click
  $('.persistent').on('change', function() {
    if ($(this).is(':checkbox')) {
      if ($(this).is(':checked')) {
        localStorage[$(this).attr('id')] = 1;
      }
      else {
        localStorage[$(this).attr('id')] = 0;
      }
    }
    else {
      localStorage[$(this).attr('name')] = $(this).val(), $(this).find('option:selected').val();  // eslint-disable-line
    }
  });

  if ($(window).width() < 1100) {
    $('#filter-wrap').addClass('closed');
  }

  $('#JS-toggle-filter-mobile').click(function() {
    $('#filter-wrap').removeClass('closed');
  });

  $('.filter-wrap-simple .btn').click(function() {
    $('#filter-wrap').addClass('closed');
  });

  $(window).resize(function() {
    if ($(window).width() < 1100) {
      $('#filter-wrap').addClass('closed');
    }
  });

  $('#copy').click(function() {
    navigator.clipboard.writeText(window.location.href);
    $('.copy').addClass('ok');
  });
});
